import { Factory, QuickFactory } from '@infodata-group/inf-commons';
import { VehicleMaintenance } from '../model/vehicle-maintenance';
import { VehicleMaintenanceDto } from '../interface/vehicle-maintenance.dto';

export class VehicleMaintenanceFactory
  extends QuickFactory
  implements Factory<VehicleMaintenance>
{
  private readonly vehicleId: string;

  constructor(vehicleId: string) {
    super();
    this.vehicleId = vehicleId;
  }

  build(o: VehicleMaintenanceDto): VehicleMaintenance {
    const vehicleMaintenance: VehicleMaintenance = new VehicleMaintenance();
    this.generateProperty(vehicleMaintenance, o);
    return vehicleMaintenance;
  }

  getApi(): string {
    return `administration/fleet/vehicles/${this.vehicleId}/maintenances/`;
  }
}
